namespace TabAurous.Retail {
    export namespace GiftVoucherIssueService {
        export const baseUrl = 'Retail/GiftVoucherIssue';

        export declare function Create(request: Serenity.SaveRequest<GiftVoucherIssueRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<GiftVoucherIssueRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<GiftVoucherIssueRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<GiftVoucherIssueRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Retail/GiftVoucherIssue/Create",
            Update = "Retail/GiftVoucherIssue/Update",
            Delete = "Retail/GiftVoucherIssue/Delete",
            Retrieve = "Retail/GiftVoucherIssue/Retrieve",
            List = "Retail/GiftVoucherIssue/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>GiftVoucherIssueService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
